import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { shape, string } from 'prop-types';
import { useToasts } from '@magento/peregrine';
import Toast from './toast';
import { mergeClasses } from '../../classify';
import defaultClasses from './toastContainer.css';

/**
 * A container for toast notifications.
 *
 * This component must be a child, nested or otherwise, of a
 * ToastContextProvider component.
 *
 * @typedef ToastContainer
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays toast notification data.
 */
var ToastContainer = props => {
  var classes = mergeClasses(defaultClasses, props.classes);
  var [{
    toasts
  }] = useToasts();

  // Given a map of toasts each with a property "timestamp", sort and display
  // based on the timestamp.
  var sortByTimestamp = (_ref, _ref2) => {
    var [, toastA] = _ref;
    var [, toastB] = _ref2;
    return toastA.timestamp - toastB.timestamp;
  };
  var toastElements = Array.from(toasts).sort(sortByTimestamp).map(_ref3 => {
    var [id, toast] = _ref3;
    var key = toast.isDuplicate ? Math.random() : id;
    return /*#__PURE__*/React.createElement(Toast, _extends({
      key: key
    }, toast));
  });
  return /*#__PURE__*/React.createElement("div", {
    id: "toast-root",
    className: classes.root
  }, toastElements);
};

/**
 * Props for {@link ToastContainer}
 *
 * @typedef props
 *
 * @property {Object} classes An object containing the class names for the
 *   ToastContainer and its Toast components
 * @property {String} classes.root CSS classes for the root container
 */
ToastContainer.propTypes = {
  classes: shape({
    root: string
  })
};
export default ToastContainer;